<template>
  <div class="banking-widget-container">
    <div v-if="loading" class="banking-widget-loading">Loading...</div>
    <div v-else-if="error" class="banking-widget-error">{{ error }}</div>
    <div v-else class="banking-widget-chart-placeholder">
      <div class="banking-widget-chart-summary">
        <div class="banking-widget-chart-summary-item">
          <div class="banking-widget-chart-summary-label">Total Balance</div>
          <div class="banking-widget-chart-summary-value">{{ formatCurrency(totalBalance) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './styles/BankingWidget.css';
import ApiService from '@/services/api.service';
import logger from '@/utils/logger';

export default {
  name: 'BankingWidget',
  props: {
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      totalBalance: 0,
      loading: true,
      error: null
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = null;
      try {
        const response = await ApiService.get(`/banking/company/${this.companyId}/accounts`);
        const accounts = (response.data?.accounts || []).filter(acc => acc.isActive !== false);
        this.totalBalance = accounts.reduce((sum, acc) => sum + parseFloat(acc.currentBalance || acc.balance || 0), 0);
      } catch (error) {
        logger.error('Error fetching banking data:', error);
        this.error = 'Failed to load data';
        this.totalBalance = 0;
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) return '$0.00';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    }
  }
};
</script>

